import {
  KycCurrentStatus,
  KycProcessStatus,
  type KycResponse,
} from '@repo/api-kit/queries/due-diligence/kyc';
import { getIdnowProviderDetails } from './get-idnow-provider-details';

const DEFAULT_POLLING_INTERVAL = 1000;

/**
 * Determines the polling interval for KYC status refetching.
 *
 * @param data - The KYC response data
 * @returns `false` to stop polling, or the polling interval in milliseconds
 *
 * @remarks
 * Polling continues (returns interval) only when **all** conditions are met:
 * - No error occurred during the last fetch
 * - IDnow provider details exist (i.e., active process uses the IDnow provider)
 * - KYC current status is `pending`
 * - Active process status is NOT `submitted`
 */
export function getKycPollingInterval(data?: KycResponse, error?: Error | null): number | false {
  if (error) {
    return false;
  }

  const isKycCurrentStatusNotPending = data?.kycCurrentStatus !== KycCurrentStatus.pending;
  const isKycProcessStatusSubmitted =
    data?.activeProcess?.processStatus === KycProcessStatus.submitted;
  const idnowProviderDetails = getIdnowProviderDetails(data);

  if (!idnowProviderDetails || isKycCurrentStatusNotPending || isKycProcessStatusSubmitted) {
    return false;
  }

  return DEFAULT_POLLING_INTERVAL;
}
